import { useEffect } from 'react';

import { Route, Routes, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { notifications } from 'ui';

import { EmailConfirmationPage } from './EmailConfirmation';

const ConfirmNotification = () => {
  const navigate = useNavigate();
  const { type } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const confirmedStatus = searchParams.get('confirmed') === 'true';
    const confirmedError = searchParams.get('error');

    notifications.show({
      variant: confirmedStatus ? 'success' : 'error',
      message: confirmedError ? confirmedError : `Your ${type} has been confirmed!`,
      autoClose: 5000,
    });
    navigate('/home');
  }, [navigate, searchParams, type]);
  return <></>;
};

const ConfirmRoutes = () => {
  return (
    <Routes>
      <Route path="email" element={<EmailConfirmationPage />} />
      <Route path=":type" element={<ConfirmNotification />} />
    </Routes>
  );
};

export { ConfirmRoutes };
